import { render } from "./NewTeamView.vue?vue&type=template&id=7b9e530a&scoped=true"
import script from "./NewTeamView.vue?vue&type=script&lang=js"
export * from "./NewTeamView.vue?vue&type=script&lang=js"

import "./NewTeamView.vue?vue&type=style&index=0&id=7b9e530a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9e530a"]])

export default __exports__